import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PainPoint {
  id: string;
  text: string;
}

interface PainPointListProps {
  points: PainPoint[];
}

export default function PainPointList({ points }: PainPointListProps) {
  return (
    <ul className="space-y-3 sm:space-y-4 mt-4 sm:mt-6">
      {points.map((point) => (
        <li key={point.id} className="flex items-start gap-2 sm:gap-3 text-foreground">
          <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-muted flex items-center justify-center shrink-0 mt-0.5 sm:mt-1">
            <Icon name="XMarkIcon" size={12} className="text-accent sm:w-3.5 sm:h-3.5" />
          </div>
          <span className="text-sm sm:text-base leading-relaxed">{point.text}</span>
        </li>
      ))}
    </ul>
  );
}